import { TableContent } from './TableContent'
import { LoadMoreButton } from '@ztechapps/webui.button'
import React from 'react'
import type { TableProps } from './index'

export const TableAndLoadMoreContent = (props: TableProps) => {
  return (
    <>
      <TableContent {...props} />
      <LoadMoreButton {...props} />
    </>
  )
}
